module.exports = __webpack_public_path__ + "static/media/noun-553134-cc.6bac4a52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/noun-553134-cc.svg
// module id = 257
// module chunks = 0